import Locale from "./Locale";

export const pleaseCallPoolsideSupportReason = Locale.gettext("The app encountered a problem.");
export const pleaseCallPoolsideSupportContact = Locale.gettext("If this issue persists, contact Poolside Tech support for assistance!") +
    "\n\n" + Locale.gettext("https://poolside.support/contact-us or +1-267-810-0600")
;